<template>
    <b-card no-body>
        <!-- Card image -->
        <img class="card-img-top" :src="currentBook.thumb" alt="Image placeholder">
        <!-- Card body -->
        <b-card-body>
            <div class="loader" v-if="loading"></div>
            <b-card-title class="h2 mb-0">Find your Pre-Order here</b-card-title>
            <small class="text-muted">Your editorial assistant: {{ currentBook.editor }} | {{ formatDate(currentBook.updated_at) }} </small>
            <b-card-text class="mt-4">
                Click here to see your Pre-Order page in our shop. Please use this link when you advertise your presale to
                potiantial customers.
                <br><br>
                
                <h4>Your Pre-Order Qr-Code:</h4>

                <!-- QR Code as image -->
                <div class="qr-code-container text-left mb-4" v-if="currentBook.presale_qrcode_svg">
                    <img :src="currentBook.presale_qrcode_svg" alt="Pre-Order QR Code">
                </div>

                <h4>Your Pre-Order address:</h4>
                <div class="input-group input-group-merge">
                    <div class="input-group-prepend">
                        <span class="input-group-text">
                            <i class="fas fa-globe-americas"></i>
                        </span>
                    </div>
                    <input class="form-control" id="firsttimelink" placeholder="Project link" type="text"
                        :value="currentBook.presale_link">
                    <span class="input-group-append">
                        <div class="btn btn-dark" @click="copyURL('{{ currentBook.presale_link }}')">
                            Copy Link
                        </div>
                    </span>
                </div>
            </b-card-text>
            <!-- a href="#!" class="btn btn-sm btn-dark">download now</a -->
        </b-card-body>
    </b-card>

</template>

<script>
import { mapGetters } from "vuex";
import moment from 'moment'

export default {
    name: "presale-photo-book",
    components: {
    },
    data() {
        return {
            loading: false,
            currentBook: [],
        };
    },
    props: {
        photoBookId: '',
        hasQrCode: false,
    },
    methods: {
        retrieveBook() {
            this.loading = true;
            this.$api.getPhotoBook(this.photoBookId)
                .then((response) => {
                    console.log(response);
                    this.currentBook = response.data;
                    console.log(this.currentBook);
                })
                .catch((e) => {
                    console.log(e);
                }).finally(() => {
                    this.loading = false
                });
        },
        formatDate(date) {
            return moment(date).format("Do MMM YYYY")
        },
        async copyURL(mytext) {
            try {
                
            await navigator.clipboard.writeText(mytext);
            alert('Copied');
            } catch($e) {
            alert('Cannot copy');
            alert($e);
            }
        }
    },
    computed: {
        ...mapGetters({ currentAccount: 'currentAccount' }),
        commentsLoaded: function () {
            return this.currentBook ? true : false;
        }
    },
    mounted() {
        this.retrieveBook();
    },
};
</script>

<style scoped>
.qr-code-container {
    max-width: 200px;
    /*margin: 0 auto;*/
}

.qr-code-container img {
    width: 100%;
    height: auto;
}
</style>